
import React from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { toast } from 'sonner';
import { deleteForm } from '@/lib/supabase/forms';
import { Form } from '@/components/dashboard/shops/types';

interface DeleteFormDialogProps {
  isOpen: boolean;
  onClose: () => void;
  form: Form | null;
  onSuccess: () => void;
}

export const DeleteFormDialog: React.FC<DeleteFormDialogProps> = ({
  isOpen,
  onClose,
  form,
  onSuccess,
}) => {
  const handleDelete = async () => {
    if (!form) return;
    
    try {
      const { success, error } = await deleteForm(form.id);
      
      if (success) {
        toast.success("Formulaire supprimé avec succès");
        onSuccess();
      } else {
        throw new Error(error?.message || "Erreur lors de la suppression du formulaire");
      }
    } catch (error: any) {
      toast.error("Erreur", {
        description: error.message || "Une erreur est survenue lors de la suppression du formulaire"
      });
    } finally {
      onClose();
    }
  };

  return (
    <AlertDialog open={isOpen} onOpenChange={onClose}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Êtes-vous sûr de vouloir supprimer ce formulaire ?</AlertDialogTitle>
          <AlertDialogDescription>
            Cette action est irréversible. Le formulaire "{form?.name}" sera définitivement supprimé.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Annuler</AlertDialogCancel>
          <AlertDialogAction onClick={handleDelete} className="bg-destructive text-destructive-foreground hover:bg-destructive/90">
            Supprimer
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
